
import React, { useRef, useState, useCallback, useEffect } from "react";
import "./Nosotros.css";
import { useNavigate } from "react-router-dom";

const Nosotros = () => {
    const navigate = useNavigate();
    const textPathRef = useRef(null);
    const animateRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [currentOffset, setCurrentOffset] = useState(-32);
    const [isAnimating, setIsAnimating] = useState(true);

    // Función para pausar/reanudar la animación nativa de SVG
    const toggleAnimation = useCallback((play) => {
        if (animateRef.current) {
            if (play) {
                animateRef.current.beginElement();
            } else {
                // Para pausar la animación SVG
                const computedStyle = window.getComputedStyle(animateRef.current);
                if (computedStyle.animationPlayState) {
                    animateRef.current.style.animationPlayState = 'paused';
                }
            }
        }
    }, []);

    const handleMouseDown = useCallback((e) => {
        setIsDragging(true);
        setStartX(e.clientX);
        setIsAnimating(false);
        toggleAnimation(false);
        e.preventDefault();
    }, [toggleAnimation]);

    const handleMouseMove = useCallback((e) => {
        if (!isDragging) return;

        const deltaX = startX - e.clientX; // Invertido para dirección natural
        const sensitivity = 0.02;
        const newOffset = currentOffset - (deltaX * sensitivity);

        setCurrentOffset(newOffset);

        if (textPathRef.current) {
            textPathRef.current.setAttribute("startOffset", newOffset + "%");
        }

        setStartX(e.clientX);
    }, [isDragging, startX, currentOffset]);

    const handleMouseUp = useCallback(() => {
        if (isDragging) {
            setIsDragging(false);
            setIsAnimating(true);
            toggleAnimation(true);
        }
    }, [isDragging, toggleAnimation]);

    const handleMouseLeave = useCallback(() => {
        if (isDragging) {
            setIsDragging(false);
            setIsAnimating(true);
            toggleAnimation(true);
        }
    }, [isDragging, toggleAnimation]);




    return (
        <section className="nosotros">
            <div className="nosotros-top">
                <p className="nosotros-slogan">
                    we make it <span>happen.</span>
                </p>

                <div className="nosotros-banner">
                    <div className="nosotros-texto">
                        <div className="nosotros-puntos">
                            <img
                                src="/images/logo/MotiPuntos.svg"
                                alt="puntos"
                                className="puntos"
                            />
                        </div>
                        <h2>
                            ¿Quiénes <em>somos?</em>
                        </h2>
                        <h3>Tu mejor opción en impresión.</h3>
                    </div>

                    <img
                        src="/images/nosotros/nubes.png"
                        alt="nubes decorativas"
                        className="nubes"
                    />
                    <img
                        src="/images/nosotros/nubes2.png"
                        alt="nubes decorativas 2"
                        className="nubes2"
                    />
                    <img
                        src="/images/nosotros/espectacular.png"
                        alt="espectacular"
                        className="espectacular"
                    />
                </div>
            </div>

            <div className="nosotros-bottom">
                <div className="nosotros-info">
                    <div className="nosotros-puntos">
                        <img
                            src="/images/logo/MotiPuntos.svg"
                            alt="puntos"
                            className="puntos"
                        />
                    </div>
                    <h2>
                        El único partner de impresión que vas a necesitar.
                    </h2>
                    <p>
                        Expertos en ofrecer infinitas soluciones creativas para que tu marca
                        y producto destaquen en el mercado actual.
                    </p>
                    <button className="btn-saber">
                        Saber más
                        <img src="/images/nosotros/arrow.svg" alt="flecha" />
                    </button>
                </div>

                <div className="nosotros-grid">
                    <div className="grid-item" style={{ backgroundColor: "#461B32" }}>
                        <img src="/images/nosotros/bolsas.svg" alt="Bolsas" />
                        <p className="squaretittle">Bolsas Pouch</p>
                    </div>
                    <div className="grid-item" style={{ backgroundColor: "#C52228" }}>
                        <img src="/images/nosotros/granformato.svg" alt="Gran formato" />
                        <p className="squaretittle">Gran formato</p>
                    </div>
                    <div className="grid-item" style={{ backgroundColor: "#E67926" }}>
                        <img src="/images/nosotros/etiquetas.svg" alt="Etiquetas" />
                        <p className="squaretittle">Etiquetas & mangas</p>
                    </div>
                    <div className="grid-item" style={{ backgroundColor: "#E6DCC4" }}>
                        <img src="/images/nosotros/brand.svg" alt="Brand" />
                        <p className="squaretittle">Brand experience</p>
                    </div>
                    <div className="grid-item" style={{ backgroundColor: "#5FB4AC" }}>
                        <img src="/images/nosotros/packaging.svg" alt="Packaging" />
                        <p className="squaretittle">Packaging de lujo</p>
                    </div>
                    <div className="grid-item" style={{ backgroundColor: "#682C15" }}>
                        <img src="/images/nosotros/visual.svg" alt="Visual Merch" />
                        <p className="squaretittle">Visual Merch</p>
                    </div>
                    <div className="grid-item" style={{ backgroundColor: "#F49D1A" }}>
                        <img src="/images/nosotros/estructuras.svg" alt="Estructuras" />
                        <p className="squaretittle">Estructuras y displays</p>
                    </div>
                </div>
            </div>
            <div className="nosotros-historia">

                <div className="historia-left">
                    <video
                        src="/videos/videous.mp4"
                        autoPlay
                        muted
                        loop
                        className="historia-video"
                    ></video>
                </div>

                <div className="historia-right">
                    <p className="historia-tag">Nuestra historia</p>

                    <h2 className="historia-title">
                        Nuestros números hablan por sí mismos
                    </h2>

                    <p className="historia-desc">
                        Moti Digital fue fundado en 2004 por Alberto García de Quevedo,
                        un ingeniero en electrónica que detectó la transición hacia la
                        impresión digital como una oportunidad clave en la industria gráfica.
                    </p>

                    <div className="historia-stats">
                        <div className="stat">
                            <h3>300+</h3>
                            <p>Colaboradores</p>
                        </div>

                        <div className="stat">
                            <h3>20+</h3>
                            <p>Años de experiencia</p>
                        </div>

                        <div className="stat">
                            <h3>1,000+</h3>
                            <p>Clientes satisfechos</p>
                        </div>

                        <div className="stat">
                            <h3>2,500+</h3>
                            <p>Proyectos en América</p>
                        </div>
                    </div>

                    <button className="historia-btn">
                        Conoce la MotiHistoria completa
                    </button>
                </div>

            </div>
            {/* === BLOQUE VALORES === */}

            <div className="valores-container">
                <div className="valores-textos">
                    <span className="tag">Nuestros valores</span>

                    <h2 className="titulo">
                        Fundamentos que nos <br />
                        <span className="inspiran">inspiran</span>
                    </h2>

                    <p className="descripcion">
                        Nuestra forma de trabajar está sustentada en valores claros, objetivos
                        sólidos y estándares internacionales de calidad.
                    </p>

                    <p className="frase">
                        "Nuestra esencia combina el rush por innovar, la pasión que nos mueve,
                        la fuerza del equipo, la alegría que inspira y la adaptabilidad que nos
                        impulsa a crecer."
                    </p>
                </div>

            </div>

            <div className="commitment">
                <span className="badge-huella"><img
                    className="huella"
                    src="/images/logo/huella-dactilar.png"
                    alt="huella digital"
                /> Nuestro compromiso</span>

                <h2>
                    Conoce nuestro compromiso
                    <br />
                    <strong>con la excelencia</strong>
                </h2>

                <div className="grid">
                    {/* ISO */}
                    <div className="cardiso iso">
                        <p className="small">Contamos con:</p>
                        <h3>CERTIFICACIÓN ISO 9001</h3>

                        <img
                            className="iso-img"
                            src="/images/logo/iso-9001.png"
                            alt="Certificación ISO 9001"
                        />
                    </div>

                    {/* Política */}
                    <div className="cardiso policy">
                        <img alt="puntos" class="puntos-iso" src="/images/logo/MotiPuntos.svg" />
                        <h3>Política de calidad</h3>
                        <p>
                            En <strong>Moti</strong> nos enfocamos en garantizar la
                            <strong> satisfacción de nuestros clientes</strong> a través de
                            nuestra cultura de <strong>servicio extraordinario</strong> y
                            operación eficaz, trabajando bajo nuestro sistema de gestión
                            integral, cuidando del medio ambiente, la seguridad y salud de
                            nuestros colaboradores y fomentando la
                            <strong> mejora continua</strong> de nuestros procesos.
                        </p>
                    </div>

                    {/* Misión */}
                    <div className="cardiso mission">
                        <h3>Misión</h3>
                        <p>
                            Identificar constantemente nuevas oportunidades de negocio para
                            marcas y personas.
                        </p>
                    </div>

                    {/* Propósito */}
                    <div className="cardiso purpose">
                        <h3>Propósito</h3>
                        <p>
                            Impulsar la comunicación visual de las marcas a través de soluciones
                            de impresión innovadoras, personalizadas y de alta calidad.
                        </p>
                    </div>
                </div>
            </div>

            <div className="marquee-container">
                <div className="marquee">
                    <svg
                        className="svgwave"
                        width="100%"
                        height="100%"
                        xmlns="http://www.w3.org/2000/svg"
                        onMouseDown={handleMouseDown}
                        onMouseMove={handleMouseMove}
                        onMouseUp={handleMouseUp}
                        onMouseLeave={handleMouseLeave}
                        style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
                    >
                        <path id="wavepath" d="M-400,59.580000000000005  L-400,59.580000000000005 S-133.20000000000002,149.58 0,149.58 S266.79999999999995,59.580000000000005 400,59.580000000000005 S666.8,149.58 800,149.58 S1066.8,59.580000000000005 1200,59.580000000000005 S1466.8,149.58 1600,149.58 S1866.8,59.580000000000005 2000,59.580000000000005" />

                        <text textAnchor="middle">
                            <textPath
                                ref={textPathRef}
                                id="my-text"
                                className="my-text"
                                href="#wavepath"
                                startOffset={isAnimating ? undefined : `${currentOffset}%`}
                            >
                                LO ÚLTIMO QUE CREAMOS » LO ÚLTIMO QUE CREAMOS » LO ÚLTIMO QUE CREAMOS » LO ÚLTIMO QUE CREAMOS »
                                LO ÚLTIMO QUE CREAMOS » LO ÚLTIMO QUE CREAMOS » LO ÚLTIMO QUE CREAMOS » LO ÚLTIMO QUE CREAMOS »

                                {isAnimating ? (
                                    <animate
                                        ref={animateRef}
                                        attributeName="startOffset"
                                        from="100%"
                                        to="0%"
                                        begin="0s"
                                        dur="30.5s"
                                        repeatCount="indefinite"
                                        calcMode="linear"
                                    />
                                ) : null}
                            </textPath>
                        </text>
                    </svg>
                </div>
            </div>

            <div className="latest-header">
                <span className="badge">Nuestros proyectos</span>
                <h2>
                    Un vistazo a nuestras soluciones<br />
                    más recientes
                </h2>
                <p>donde creatividad y tecnología se encuentran.</p>
            </div>

            <div className="projects-grid">

                <article className="project-card" style={{ '--bg': "url('/images/projects/project1.png')" }} >
                    <img className="project-card-img" src="/images/projects/project1.png" alt="" />
                    <span className="tag-proj orange"> <img className="hoja-img" src="/images/projects/hoja-1.svg" alt="" /> Proyecto especial</span>
                    <h3>American Eagle – Neon w/ Domelipa</h3>
                    <p>
                        Un proyecto vibrante que mezcla luz, color y estilo para
                        resaltar la energía juvenil de la marca junto a Domelipa.
                    </p>
                     <button onClick={(e) => { e.stopPropagation(); navigate('/AE'); }}>
        Leer proyecto completo
    </button>
                </article>

                <article className="project-card" style={{ '--bg': "url('/images/projects/project2.png')" }} >
                    <img className="project-card-img" src="/images/projects/project2.png" alt="" />
                    <span className="tag-proj green">  <img className="hoja-img" src="/images/projects/hoja-2.svg" alt="" /> Proyecto especial</span>
                    <h3>Pandora – Degradados perfectos</h3>
                    <p>
                        Un trabajo de precisión donde los tonos se funden de manera
                        impecable, reflejando la elegancia y sofisticación de Pandora.
                    </p>
                     <button onClick={(e) => { e.stopPropagation(); navigate('/pandora'); }}>
        Leer proyecto completo
    </button>
                </article>

                <article className="project-card" style={{ '--bg': "url('/images/projects/project3.png')" }} >
                    <img className="project-card-img" src="/images/projects/project3.png" alt="" />
                    <span className="tag-proj pink">  <img className="hoja-img" src="/images/projects/hoja-3.svg" alt="" /> Proyecto especial</span>
                    <h3>American Eagle – Primavera con Domelipa</h3>
                    <p>
                        Una propuesta fresca llena de vida que transmite el espíritu
                        de la temporada con un toque creativo y moderno.
                    </p>
                   <button onClick={(e) => { e.stopPropagation(); navigate('/AE2'); }}>
        Leer proyecto completo
    </button>
                </article>

            </div>


        </section>

    );
};

export default Nosotros;
